import React from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { dateLocale } from './templates/format';

function greetingKey() {
  const hour = new Date().getHours();
  if (hour < 10) return 'dashboard.greeting.morning';
  if (hour < 17) return 'dashboard.greeting.day';
  return 'dashboard.greeting.evening';
}

/** Fixed chrome above the grid: time-of-day greeting, date · organization, edit entry point. */
export default function GreetingRow({ user, organization, isMobile, onEdit }) {
  const { t } = useTranslation();
  const firstName = (user?.name || '').trim().split(/\s+/)[0] || '';
  const greeting = t(greetingKey());
  return (
    <Box data-testid="dashboard-greeting" sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, mb: 2.5 }}>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          component="h1"
          sx={{ m: 0, fontSize: isMobile ? 22 : 26, fontWeight: 700, letterSpacing: '-0.5px', color: 'text.primary', display: 'flex', alignItems: 'center', gap: 1, fontFamily: "'Plus Jakarta Sans', sans-serif" }}
        >
          {firstName ? `${greeting}, ${firstName}` : greeting}
          <Box component="span" sx={{ fontSize: isMobile ? 20 : 24 }}>
            👋
          </Box>
        </Typography>
        <Typography sx={{ fontSize: 14, color: 'text.secondary', mt: 0.5 }}>
          {format(new Date(), 'cccc d.M.yyyy', { locale: dateLocale() })}
          {organization?.organization_name ? ` · ${organization.organization_name}` : ''}
        </Typography>
      </Box>
      {isMobile ? (
        <IconButton data-testid="dashboard-edit-button" aria-label={t('dashboard.edit.customize')} onClick={onEdit} sx={{ border: '1px solid #e2e8f0', borderRadius: '10px', width: 40, height: 40 }}>
          <TuneIcon />
        </IconButton>
      ) : (
        <Button data-testid="dashboard-edit-button" variant="outlined" startIcon={<TuneIcon />} onClick={onEdit} sx={{ flexShrink: 0, borderRadius: '10px', borderColor: 'divider', color: 'text.primary', bgcolor: 'background.paper', '&:hover': { borderColor: 'secondary.main', bgcolor: 'background.paper' } }}>
          {t('dashboard.edit.customize')}
        </Button>
      )}
    </Box>
  );
}
